// client/src/components/plataforma/siteInstitucional/useHomePersonalizadaGate.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../../../hooks/useAuth';
import useContaPlan from '../../../hooks/useContaPlan';
import useFranquiaPlan from '../../../hooks/useFranquiaPlan';

// Mesma lógica de ConfiguracoesHomePage.js — matriz é dona do template padrão
// que todo mundo usa, nunca é bloqueada. Conta/franquia sem a feature
// 'hasHomePersonalizada' no plano ficam em modo de visualização (mantém o
// que já tem funcionando, só bloqueia editar).
export function useHomePersonalizadaGate() {
    const { scope: userScope } = useAuth();
    const contaPlan = useContaPlan();
    const franquiaPlan = useFranquiaPlan();

    const hasHomePersonalizada = userScope === 'matriz'
        ? true
        : userScope === 'franquia'
            ? franquiaPlan.hasFeature('hasHomePersonalizada')
            : contaPlan.hasFeature('hasHomePersonalizada');

    return { hasHomePersonalizada, userScope };
}

export function HomePersonalizadaUpsellBanner() {
    return (
        <div className="content-panel mt-6" style={{ borderLeft: '4px solid #f59e0b', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Lock size={20} style={{ flexShrink: 0, color: '#f59e0b' }} />
            <div>
                <strong>Home personalizada disponível a partir de um plano superior.</strong>
                <p className="text-sm text-gray-500" style={{ margin: 0 }}>
                    Você está vendo o conteúdo atual em modo de visualização. Para criar, editar ou reordenar itens, faça upgrade do seu plano.
                </p>
            </div>
            <Link to="/assinatura?reason=feature" className="action-button action-button-primary" style={{ marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                Ver planos
            </Link>
        </div>
    );
}
